<template>
  <div class="content-wrapper">
    <div class="page-content-detail">
      <div v-if="current_content" class="page-content-detail-image"
           v-bind:style="{ 'background-image': 'url(' + current_content.contentImageUrl + ')' }">
      </div>

      <div class="blog-content-wrapper">
      <div  class="blog-content" v-if="current_content">
        <h4 class="blog-header">{{ current_content.name }}</h4>
        <div v-html="current_content.longContent"></div>
      </div>
      <div class="related-blogs-panel">
        <h3>More Blogs</h3>
        <ul class="related-blogs-list" v-if="contentData">
          <li v-for="(page) in contentData.data" :key="page.id" :blog="page">
            <a :href="`/blog/${page.alias}`">{{page.name}}</a>
          </li>
        </ul>
      </div>
      </div>
    </div>
    <h1 class="text-primary mt-4 related-restaurants-title" v-if="current_content && current_content.restaurants.length>0">Taste With These Restaurants</h1>

    <blog-related-restaurant v-if="current_content" :restaurants="current_content.restaurants"> </blog-related-restaurant>

  </div>
</template>

<script>

import BlogRelatedRestaurant from './components/BlogRelatedRestaurant'

export default {
  props: {
    content_id: {
      type: String
    }
  },
  components: {
    BlogRelatedRestaurant
  },
  metaInfo () {
    return {
      title: this.current_content.name,
      titleTemplate: '%s | Turkish Restaurant Blog',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `${this.current_content.shortContent}`
        }
      ]
    }
  },
  data () {
    return {
      contentData: null
    }
  },
  mounted () {
    this.getContent()
    this.moreContentList()
  },
  computed: {
    meta_title () {
      let res = ''
      if (this.content_id.includes('-')) {
        this.content_id.split('-').map(word => {
          let wordie = word.substr(0, 1).toUpperCase()
          wordie += word.substr(1).toLowerCase()
          wordie += ' '
          res += wordie
        })
      }
      return res
    },
    current_content () {
      return this.$store.state.api.current_content
    }
  },
  methods: {

    getContent () {

      this.$vs.loading()

      const payload = {
        contentId: this.content_id
      }

      this.$store.dispatch('api/getContent', payload)
        .then(() => {
          this.$vs.loading.close()
          this.$meta().refresh()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    moreContentList () {
      this.$vs.loading()
      const payload = {
        contentType: 'blog',
        page: 1,
        limit: 4,
        rand: true
      }

      this.$store.dispatch('api/contentList', payload)
        .then((response) => {
          this.$vs.loading.close()
          this.contentData = response.data
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    }
  }
}
</script>

<style lang="scss">
.blog-content-wrapper{
  display:flex;
  justify-content:space-between;
  margin-top:20px;
  .blog-content{
    width:calc(70% - 5px);
  }
  .related-blogs-panel{
    width:calc(30% - 5px);
    padding:20px;
    box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.1);
    max-height: max-content;
    align-self:flex-start;
    .related-blogs-list{
      a {
       color:#222;
       font-weight: bold;
      }
      li{
      margin-bottom:10px;
      padding:10px;
      border-left:5px solid rgba(255,36,0,1);
      box-shadow: 0px 2px 3px 1px rgba(0,0,0,0.1);
      }

    }
  }
}

.related-restaurants-title{
  text-align: center;
  width:100%;
  padding:20px;
  background-color:#f2f2f2;
  font-weight: 900;
}
.blog-header {
  text-align:left;
  font-size:42px;
  margin-bottom:20px;
  font-weight:900;
}
.blog-content{
  font-family:'Times New Roman', Times, serif;
  padding:20px;
  background-color:#eeeae2;
  ul{
    margin-left:20px;
list-style: disc;
  }
  h2{
    margin-bottom:20px;
  }
  span{
    font-weight:bold;
  }
  p{
    margin-bottom:0px;
    }
  color:#000;
  font-size:16px;
}
.page-content-detail-image {
  height: 450px;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
@media (max-width:768px){
.blog-header{
  margin:20px auto;
}
.blog-content-wrapper{
  display:block;
  .blog-content{
    width:100%;
  }
  .related-blogs-panel{
    width:100%;
    margin-top:20px;
  }
}
}
</style>
